/**
 * The pages a user can spend project time on. Sent with the project access
 * log time-in/time-out calls so the User Sessions report can break a project's
 * total time down by page.
 *
 * Keep in sync with Core.Models.ProjectAccessAreas on the server.
 */
export const ProjectAccessArea = {
  ProjectSummary: 'Project Summary',
  Readiness: 'Readiness',
  ReadinessAdmin: 'Readiness Admin',
  ReadinessSettings: 'Readiness Settings',
  Execution: 'Execution',
  ProjectSetup: 'Project Setup'
} as const;

export type ProjectAccessAreaName = typeof ProjectAccessArea[keyof typeof ProjectAccessArea];

/**
 * How long a project page waits on an idle user before closing its access log
 * row and sending them back to the dashboard.
 *
 * Every tracked page reads this, so the areas of a breakdown are all measured
 * against the same cut-off. Core.Models ProjectAccessLogRepository.IdleTimeoutMinutes
 * subtracts the same window server side - change both together.
 */
export const PROJECT_IDLE_TIMEOUT_MS = 900000;
